import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { Auth } from 'aws-amplify';

const createAxiosInstance = (baseURL: string) => {
  const axiosInstance = axios.create({
    baseURL,
  });

  const getAuthHeaders = async (): Promise<AxiosRequestConfig> => {
    const token = await Auth.currentSession();
    const accessToken = token?.getIdToken();

    return {
      headers: {
        Authorization: `Bearer ${accessToken?.getJwtToken()}`,
        'Content-Type': 'application/json',
      },
    };
  };

  axiosInstance.interceptors.request.use(
    async (config: any) => {
      const authHeaders = await getAuthHeaders();
      config.headers = { ...config.headers, ...authHeaders.headers };
      return config;
    },
    (error) => Promise.reject(error)
  );

  const responseBody = (response: AxiosResponse) => response.data;

  const requests = {
    get: (url: string, config?: {}) =>
      axiosInstance.get(url, config).then(responseBody),
    post: (url: string, body: {}, config?: AxiosRequestConfig) =>
      axiosInstance.post(url, body, config).then(responseBody),
    put: (url: string, body: {}, config?: {}) =>
      axiosInstance.put(url, body, config).then(responseBody),
    patch: (url: string, body: {}, config?: {}) =>
      axiosInstance.patch(url, body, config).then(responseBody),
    delete: (url: string, config?: {}) =>
      axiosInstance.delete(url, config).then(responseBody),
  };

  return requests;
};

export default createAxiosInstance;
